const BottomMenuLegalNote = () => {
    return (
        <span className='bottomMenuLegalSingleLine'>
            By continuing, you agree to{' '}
            <a style={{ color: 'inherit', textDecoration: 'underline' }} href='/terms.html'>
                Terms
            </a>
            {' '}&amp;{' '}
            <a style={{ color: 'inherit', textDecoration: 'underline' }} href='/privacy.html'>
                Privacy
            </a>
        </span>
    );
};

export default BottomMenuLegalNote;
